"use client";

import { RocketIcon } from "@radix-ui/react-icons";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { DIALOG } from "@/utils/dialog-routes";

const ClaimBountyActionItems = () => {
  return (
    <>
      <Alert className="w-full text-left">
        <div
          className="
            flex flex-col items-center justify-between gap-y-4
            sm:flex-row sm:gap-x-4
          "
        >
          <div className="flex gap-x-4">
            <RocketIcon
              className="
                hidden size-6 text-muted
                sm:block
              "
            />

            <div>
              <AlertTitle>Heads up!</AlertTitle>

              <AlertDescription>
                <div>
                  Bounties decrease exponentially and continuously as people
                  claim them.
                </div>
              </AlertDescription>
            </div>
          </div>

          <Button
            size="sm"
            className="
                  block w-full items-center gap-2
                  sm:flex sm:w-auto
                "
            onClick={() =>
              setDialog(DIALOG.ClaimBounty, {
                open: true,
              })
            }
          >
            Claim Your Bounty
          </Button>
        </div>
      </Alert>
    </>
  );
};

export default ClaimBountyActionItems;
